import styled from "styled-components";

export const EmptyBinMessage = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #404040;

  & img {
    width: 48px;
    height: 48px;
    filter: grayscale(1) opacity(0.5);
  }
`;
